module.exports = __webpack_public_path__ + "static/media/chordd-magic.69445e6d.png";